import { Injectable } from '@angular/core';

@Injectable()
export class CompartilhadoContadorHttpService {

  public static instancia: CompartilhadoContadorHttpService = null;
  private _contador = 0;

  constructor() {
    return CompartilhadoContadorHttpService.instancia = CompartilhadoContadorHttpService.instancia || this;
  }

  public static obterInstancia() {
    return this.instancia;
  }

  public somarAoContador() {
    this._contador++;
  }

  public subtrairDoContador(): number {
    this._contador--;
    return this.contador;
  }

  public get contador(): number {
    return this._contador;
  }
  
}
